import dateFunctions, { isDateEarlierThan,isDateValid } from "../../../../definition/calendar/dateFunctions";
import dateByAddingSpan from "../../../../definition/calendar/dateFunctions/dateByAddingSpan";
import { isTimespanZero,timespanForPrecision } from "../../../../definition/calendar/dateFunctions/timespanFunctions";
import { setItemEndDate,setItemPreferredEndDate } from "./setEndDate";
/**
 *
 * @param {DateRecord} latestStart
 * @param {DateRecord} preferredStart
 * @param {TimeSpanRecord} duration
 * @param {CalendarRecord} calendar
 */
export const setItemLatestStartDate = (obj, timestamp, precision, calendar) => {
  if (obj.isDateLocked) {
    return obj;
  }

  let newObj = obj;
  const latestDate = dateFunctions.dateWithTimestamp(calendar, timestamp, precision);
  const preferredStartDate = newObj.preferredStartDate;

  const isLatestStartEarlierThanEnd = (duration, ignoreZeroDuration) => {
    // if ignore zero duration, will return true when duration is zero
    if (
      isDateValid(latestDate) &&
      isDateValid(preferredStartDate) &&
      duration &&
      (!ignoreZeroDuration || !isTimespanZero(duration))
    ) {
      const end = dateFunctions.dateByAddingSpan(calendar, preferredStartDate, duration);
      return isDateEarlierThan(calendar, latestDate, end);
    }
    return true;
  };

  // Don't allow setting latestStartDate if it is earlier than the preferredStartDate
  // or it is later than the end dates
  if (isDateValid(latestDate)) {
    if (isDateValid(preferredStartDate)) {
      if (isDateEarlierThan(calendar, preferredStartDate, latestDate)) {
        const { durationToEarliestEnd, preferredDuration } = obj;
        if (
          obj.ongoing ||
          (durationToEarliestEnd && isLatestStartEarlierThanEnd(durationToEarliestEnd)) ||
          (!durationToEarliestEnd && isLatestStartEarlierThanEnd(preferredDuration, true))
        ) {
          newObj = newObj.set("latestStartDate", latestDate);
          if (isTimespanZero(preferredDuration)) {
            const endDate = dateByAddingSpan(calendar, latestDate, timespanForPrecision(latestDate.precision));
            newObj = setItemPreferredEndDate(newObj, endDate.timestamp, endDate.precision, calendar);
            newObj = setItemEndDate(newObj, endDate.timestamp, endDate.precision, calendar);
          }
        }
      }
    } else {
      // preferred is not existed
      newObj = newObj.merge({ preferredStartDate: latestDate, startDate: latestDate, latestStartDate: latestDate });
    }
  } else {
    newObj = newObj.set("latestStartDate", latestDate);
  }
  return newObj;
};
